export const displayTypes = {
	purchaseOrders: "PurchaseOrders",
	transfers: "Transfers",
};